<tui-icon
  class="text-foreground-error-primary cursor-default bg-background-error-primary rounded-full"
  icon="@tui.circle-alert"
  tuiHintAppearance="negative"
  tuiHintDirection="end"
  [tuiHint]="message()" />
